export default __webpack_public_path__ + "static/media/landing-page-approach.967225d2.svg";